import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export const ManagedSPNIcon = () => {
  const theme = useTheme();
  const { mode } = theme.palette;
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Managed SPN VW GIT">
        <path
          id="Vector"
          d="M28.16 13.52C25.0744 13.52 22.24 12.1024 20.384 9.632C20.2936 9.5112 20.1512 9.44 20 9.44C19.8488 9.44 19.7072 9.5112 19.616 9.632C17.76 12.1024 14.9256 13.52 11.84 13.52C11.5752 13.52 11.36 13.7352 11.36 14V20H12.32V14.4696C15.3184 14.3392 18.0672 12.9848 20 10.6904C21.7656 12.7864 24.212 14.0976 26.908 14.408L11.7856 23.1392C11.6953 23.1914 11.6245 23.2715 11.5838 23.3675C11.5431 23.4634 11.5347 23.5701 11.56 23.6712C11.9776 25.3376 13.008 26.756 14.4616 27.664L19.7448 30.9664C19.8224 31.0152 19.9112 31.0392 19.9992 31.0392C20.0872 31.0392 20.176 31.0152 20.2536 30.9664L25.5368 27.664C27.48 26.4512 28.64 24.3584 28.64 22.068V14C28.64 13.7352 28.4248 13.52 28.16 13.52ZM12.5896 23.784L27.68 15.0712V18.2824L14.0632 26.144C13.3811 25.4939 12.8743 24.6822 12.5896 23.784ZM25.0296 26.8504L20 29.9936L14.9704 26.8504C14.9368 26.8296 14.9048 26.8072 14.872 26.7856L27.68 19.3912V22.068C27.68 24.0256 26.6888 25.8136 25.0296 26.8504Z"
          fill={mode === 'dark' ? '#fff' : '#757575'}
        />
      </g>
    </SvgIcon>
  );
};
